import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import colors from '@/common/colors';

type DealPriceProps = {
  price: string;
};

const useStyles = makeStyles({
  price: {
    paddingTop: '3px',
    color: colors.gray900
  }
});

const DealPrice = ({ price }: DealPriceProps) => {
  const classes = useStyles();

  return (
    <Typography
      variant="h2"
      className={classes.price}
      aria-label="Cart total price"
      data-testid="deal-cart-total-price"
    >
      {price}
    </Typography>
  );
};

export default DealPrice;
